<template>
    <div class="device-type-manange relative">
        <div class="buttons" :style="{position: button_position}">
            <el-button @click="resetForm">重置</el-button>
            <el-button @click="search">筛选</el-button>
        </div>

        <!-- 表单开始 -->
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="9" :lg="9" :xl="10">
                <span class="fs-14 pd-r-10">特属服务对象签约时间：</span>
                <el-date-picker
                        v-model="date"
                        type="month"
                        value-format="yyyy-MM"
                ></el-date-picker>
            </el-col>
        </el-row>
        <!-- 表单结束 -->
        <div class="docker_buttons">
            <el-button type="primary" :id="'doctorDownload'" @click="exportExcel">导出数据</el-button>
        </div>

        <p style="float: left;">财务汇总表 缴费总金额（元）：{{allData}}</p>
        <el-table ref="multipleTable"
                  :data="tableData"
                  border
                  style="width: 100%">
            <el-table-column width="50px" prop="no" label="序号" align="center"
                             label-class-name="label"></el-table-column>
            <el-table-column width="220" prop="order_sn" label="账单编号" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="user_name" label="特属服务对象姓名" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="mobile" label="联系电话" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="contract_time" label="特属服务对象签约时间" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="doctor_name" label="签约特属专家" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="expired_date" label="协议到期时间" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="status" label="缴费状态" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="amount" label="签约费用（元）" align="center" label-class-name="label"></el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
        ></el-pagination>
    </div>
</template>
<script>
    import {export2Excel} from "@/utils/excel";
    import env from "@/api/env";
    import {check} from "@/utils/checkData";
    import {isMobile} from "@/api/order";

    export default {
        data() {
            return {
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                date:'',
                allData:0.00,
                button_position: 'absolute',
            };
        },
        created() {
            if (isMobile()) {
                this.button_position = 'static'
            }
        },
        mounted() {
            // 获取特属服务对象列表
            this.getList();
            localStorage.setItem('prev_page', 'doctorcontract_list')
        },
        methods: {
            // 获取所有医生
            getList() {
                let params = {
                    servername: 'Ruyi_StatementsServices',
                    method: 'clientContractList',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        date: this.date,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    // if ()
                    for (var i = 0; i < res.data.data.list.list.length; i++) {

                        res.data.data.list.list[i].no = (this.page - 1) * this.perpage + i + 1

                        switch (res.data.data.list.list[i].status) {
                            case '1':
                                res.data.data.list.list[i].status = '未交';
                                res.data.data.list.list.status_number = 1;
                                break;
                            case '2':
                                res.data.data.list.list[i].status = '已交';
                                res.data.data.list.list[i].status_number = 2;
                                break;
                        }
                    }
                    this.allData = res.data.data.list.amount_count;
                    this.tableData = res.data.data.list.list;
                    this.total = res.data.data.page.count;
                });
            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            // 重置按钮
            resetForm() {
                this.date = "";
                this.page = 1;
                this.getList();
            },

            // 搜索
            search() {
                this.page = 1;
                this.getList();
            },

            // 导出数据
            exportExcel() {
                let params = {
                    servername: 'Ruyi_StatementsServices',
                    method: 'clientContractList',
                    pageinfo: {
                        page: this.page,
                        perpage: 0,
                    },
                    params: {
                        date: this.date,
                    }
                };
                let colums_list = [
                    {title: "账单编号", key: "order_sn"},
                    {title: "特属服务对象姓名", key: "user_name"},
                    {title: "联系电话", key: "mobile"},
                    {title: "特属服务对象签约时间", key: "create_date"},
                    {title: "签约特属专家", key: "doctor_name"},
                    {title: "协议到期时间", key: "expired_date"},
                    {title: "缴费状态", key: "status"},
                    {title: "签约费用（元）", key: "amount"},
                ];
                let export_data = [];
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }

                    let res_data = res.data;
                    if (parseInt(res_data.code) != 0) {
                        this.$message.error(res_data.msg);
                        return false;
                    }

                    for (let i = 0; i < res_data.data.list.list.length; i++) {
                        let status;
                        switch (res_data.data.list.list[i].status) {
                            case '1':
                                status = '未交';
                                break;
                            case '2':
                                status = '已交';
                                break;
                        }

                        let item = {
                            order_sn: res_data.data.list.list[i].order_sn,
                            user_name: res_data.data.list.list[i].user_name,
                            mobile: res_data.data.list.list[i].mobile,
                            create_date: res_data.data.list.list[i].create_date,
                            doctor_name: res_data.data.list.list[i].doctor_name,
                            expired_date: res_data.data.list.list[i].expired_date,
                            status: status,
                            amount: res_data.data.list.list[i].amount,
                        };
                        export_data.push(item);
                    }
                    export2Excel(colums_list, export_data, "导出特属服务对象签约账单报表");
                });
            }


        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .docker_buttons {
        float: right;
        margin: 30px 0px 8px 0px;

        .el-button {
            width: 150px;
            height: 32px;
            line-height: 7px;
        }
    }
</style>
